import { createSlice } from "@reduxjs/toolkit";
import deleteTeleServicePrice from "../../../rtk-apis/Setting/deleteTeleServicePrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const deleteTeleServicePriceSlice = createSlice({
    name: "deleteTeleServicePriceSlice",
    initialState,
    reducers: {
        clearDeleteTeleServicePriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteTeleServicePrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteTeleServicePrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(deleteTeleServicePrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.error = payload as any;
            });
    },
});

export default deleteTeleServicePriceSlice.reducer;
export const { clearDeleteTeleServicePriceState } = deleteTeleServicePriceSlice.actions;
